import Vue from "vue";
import VueRouter from "vue-router";

import Dashboard from "@/views/admin/Dashboard";
import CreateEvent from "@/views/CreateEvent";
import CreateEventV2 from "@/views/CreateEvent-v2";
import Event from "@/views/admin/Event";
import Tickets from "@/views/Tickets";
import PrintExample from "@/views/PrintExample";
import Reports from "@/views/Reports";
import Report from "@/views/Report";
import Login from "@/views/Login";
import Logout from "@/views/Logout";
import Events from "@/views/admin/Events";
import Fichas from "@/views/admin/Fichas";
import FinancialStatements from "@/views/FinancialStatements";
import Orders from "@/views/admin/Orders";
import Order from "@/views/admin/Order";
import PageNotFound from "@/views/PageNotFound";

import AdminUsersNew from "@/views/admin/AdminUsersNew";
import AdminUsersList from "@/views/admin/AdminUsersList";
import AdminUsersLoginHistory from "@/views/admin/AdminUsersLoginHistory";
import AdminUsersEvents from "@/views/admin/AdminUsersEvents";
import AdminUsersEdit from "@/views/admin/AdminUsersEdit";
import AdminTicketsCancel from '@/views/admin/AdminTicketsCancel'
import AdminListTickets from '@/views/admin/AdminListTickets'
import AdminOrdersResent from '@/views/admin/AdminOrdersResent'
import AdminEventCover from '@/views/admin/AdminEventCover'
import AdminEventRate from '@/views/admin/AdminEventRate'
import AdminStoreConfig from '@/views/admin/AdminStoreConfig'
import AdminConfig from '@/views/admin/AdminConfig'
import AdminListDealers from '@/views/admin/AdminListDealers'
import AdminCreateGroupedReport from '@/views/admin/AdminCreateGroupedReport'
import AdminEditGroupedReport from '@/views/admin/AdminEditGroupedReport'
import AdminGroupedReportList from '@/views/admin/AdminGroupedReportList'
import AdminTermsList from '@/views/admin/TermsList'
import AdminTermsCreate from '@/views/admin/TermsCreate'
import AdminTermsEdit from '@/views/admin/TermsEdit'
import AdminDataRestrictions from '@/views/admin/AdminDataRestrictions'
import AdminMcpTokens from '@/views/admin/AdminMcpTokens'

import OrganizerDashboard from "@/views/organizer/OrganizerDashboard";
import OrganizerRenderTickets from "@/views/organizer/OrganizerRenderTickets";
import OrganizerBatches from "@/views/organizer/OrganizerBatches";
import OrganizerBatchEdit from "@/views/organizer/OrganizerBatchEdit";
import OrganizerDealers from "@/views/organizer/OrganizerDealers";
import OrganizerDealer from "@/views/organizer/OrganizerDealer";
import OrganizerCreateTickets from "@/views/organizer/OrganizerCreateTickets";
import OrganizerListTickets from "@/views/organizer/OrganizerListTickets";
import OrganizerTicketReprints from "@/views/organizer/OrganizerTicketReprints";
import OrganizerApp from "@/views/organizer/OrganizerApp";
import OrganizerAppPrint from "@/views/organizer/OrganizerAppPrint";
import OrganizerAppValidate from "@/views/organizer/OrganizerAppValidate";
import OrganizerPrintReport from "@/views/organizer/OrganizerPrintReport";
import OrganizerTimeReport from "@/views/organizer/OrganizerTimeReport";
import OrganizerOverview from "@/views/organizer/OrganizerOverview";
import OrganizerCreateStore from "@/views/organizer/OrganizerCreateStore";
import OrganizerOrdersList from "@/views/organizer/OrganizerOrdersList";
import OrganizerEvents from "@/views/organizer/OrganizerEvents";
import OrganizerTicketTransfer from "@/views/organizer/OrganizerTicketTransfer";
import OrganizerGroupedReportDashboard from "@/views/organizer/OrganizerGroupedReportDashboard";
import Coupons from "@/views/organizer/Coupons";
import OrganizerCategories from "@/views/organizer/OrganizerCategories";

import GroupedReportGet from "@/views/grouped-report/GroupedReportGet";

import DealerDashboard from "@/views/dealer/DealerDashboard";
import DealerCreateTickets from "@/views/dealer/DealerCreateTickets";
import DealerRenderTickets from "@/views/dealer/DealerRenderTickets";
import DealerListTickets from "@/views/dealer/DealerListTickets";
import DealerOverview from "@/views/dealer/DealerOverview";

import PublicIdChangeOwner from "@/views/public/PublicIdChangeOwner";
import PublicIdDashboard from "@/views/public/PublicIdDashboard";
import PublicIdCheckVeracity from "@/views/public/PublicIdCheckVeracity";

Vue.use(VueRouter);

const routes = [
  {
    name: "Dashboard",
    path: "/",
    component: Dashboard,
    children: [
      {
        name: "CreateEvent",
        path: "novo",
        component: CreateEvent
      },
      {
        name: "CreateEventV2",
        path: "novo-v2",
        component: CreateEvent
      },
      {
        name: "UpdateEvent",
        path: "editar/:id(\\d+)",
        component: CreateEvent
      },
      {
        name: "UpdateEventV2",
        path: "editar-v2/:id(\\d+)",
        component: CreateEvent
      },
      {
        name: "Reports",
        path: "relatorios",
        component: Reports
      },
      {
        name: "Report",
        path: "relatorio/:id(\\d+)",
        component: Report
      },
      {
        name: "Events",
        path: "eventos",
        component: Events,
        children: [
          {
            name: "AdminEventCover",
            path: ":id(\\d+)/capa",
            components: {
              content: AdminEventCover
            },
            meta: {
              showModal: true
            }
          },
          {
            name: "Event",
            path: ":id(\\d+)",
            components: {
              content: Event
            },
            meta: {
              showModal: true
            }
          }
        ]
      },
      {
        name: "Fichas",
        path: "fichas",
        component: Fichas
      },
      {
        name: "AdminEventRate",
        path: "eventos/:id(\\d+)/tarifa-app",
        component: AdminEventRate
      },
      {
        name: "AdminStoreConfig",
        path: "eventos/:id(\\d+)/loja",
        component: AdminStoreConfig
      },
      {
        name: "AdminConfig",
        path: "eventos/:id(\\d+)/config",
        component: AdminConfig,
        meta: { contextTitle: true }
      },
      {
        name: "AdminListDealers",
        path: "eventos/:id(\\d+)/revendedores",
        component: AdminListDealers,
        meta: { contextTitle: true }
      },
      {
        name: "FinancialStatements",
        path: "financeiro/extrato",
        component: FinancialStatements
      },
      {
        name: "Orders",
        path: "loja/pedidos",
        component: Orders
      },
      {
        name: "AdminOrdersResent",
        path: "loja/pedidos/reenviados",
        component: AdminOrdersResent
      },
      {
        name: "Order",
        path: "loja/pedidos/:id(\\d+)",
        component: Order
      },
      {
        name: "AdminUsersNew",
        path: "usuarios/novo",
        component: AdminUsersNew
      },
      {
        name: "AdminUsersList",
        path: "usuarios/listar",
        component: AdminUsersList
      },
      {
        name: "AdminUsersLoginHistory",
        path: "usuarios/:id(\\d+)/acessos",
        component: AdminUsersLoginHistory,
        props: true
      },
      {
        name: "AdminUsersEvents",
        path: "usuarios/:id(\\d+)/eventos",
        component: AdminUsersEvents,
        props: true
      },
      {
        name: "AdminUsersEdit",
        path: "usuarios/:id(\\d+)/editar",
        component: AdminUsersEdit,
        props: true
      },
      {
        name: 'AdminTicketsCancel',
        path: 'eventos/:id(\\d+)/cancelar-ingressos',
        component: AdminTicketsCancel
      },
      {
        name: 'AdminListTickets',
        path: 'eventos/:id(\\d+)/ingressos',
        component: AdminListTickets,
        meta: { contextTitle: true }
      },
      {
        name: 'AdminCreateGroupedReport',
        path: 'relatorios/novo',
        component: AdminCreateGroupedReport
      },
      {
        name: 'AdminEditGroupedReport',
        path: 'relatorios/:token([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})/editar',
        component: AdminEditGroupedReport,
        props: true
      },
      {
        name: 'AdminGroupedReportList',
        path: 'relatorios',
        component: AdminGroupedReportList,
        props: true
      },
      {
        name: 'AdminShowGroupedReport',
        path: 'relatorios/:token([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})',
        component: GroupedReportGet
      },
      {
        name: 'AdminTermsList',
        path: 'termos',
        component: AdminTermsList
      },
      {
        name: 'AdminTermsCreate',
        path: 'termos/criar',
        component: AdminTermsCreate
      },
      {
        name: 'AdminTermsEdit',
        path: 'termos/:id(\\d+)/editar',
        component: AdminTermsEdit,
        props: true
      },
      {
        name: 'AdminDataRestrictions',
        path: 'dados-restritos',
        component: AdminDataRestrictions
      },
      {
        name: 'AdminMcpTokens',
        path: 'integracoes-mcp',
        component: AdminMcpTokens
      }
    ]
  },
  {
    name: "Tickets",
    path: "/evento/:event/de/:from/ate/:to",
    component: Tickets
  },
  {
    name: "PrintExample",
    path: "/imprimir-exemplo",
    component: PrintExample
  },
  {
    name: "Login",
    path: "/login",
    component: Login
  },
  {
    name: "PublicIdDashboard",
    path: "/id",
    component: PublicIdDashboard
  },
  {
    name: "PublicIdChangeOwner",
    path: "/id/alterar-titularidade",
    component: PublicIdChangeOwner
  },
  {
    name: "PublicIdCheckVeracity",
    path: "/id/conferir-veracidade",
    component: PublicIdCheckVeracity
  },
  {
    name: "Logout",
    path: "/logout",
    component: Logout
  },
  {
    name: "OrganizerEvents",
    path: "/organizador",
    component: OrganizerEvents
  },
  {
    name: "OrganizerGroupedReportDashboard",
    path: "/organizador/relatorios",
    component: OrganizerGroupedReportDashboard,
    children: [
      {
        name: "OrganizerShowGroupedReport",
        path: ":token([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})",
        component: GroupedReportGet
      }
    ]
  },
  {
    path: "/organizador/:organizer",
    component: OrganizerDashboard,
    children: [
      {
        name: "OrganizerBatches",
        path: "lotes",
        component: OrganizerBatches,
        children: [
          {
            name: "OrganizerBatchEdit",
            path: ":id(\\d+)",
            components: {
              content: OrganizerBatchEdit
            },
            meta: {
              showModal: true
            }
          }
        ]
      },
      {
        name: "OrganizerDealers",
        path: "revendedores",
        component: OrganizerDealers,
        children: [
          {
            name: "OrganizerDealer",
            path: ":id(\\d+)",
            components: {
              content: OrganizerDealer
            },
            meta: {
              showModal: true
            }
          }
        ]
      },
      {
        name: "OrganizerCreateTickets",
        path: "ingressos/imprimir",
        component: OrganizerCreateTickets
      },
      {
        name: "OrganizerListTickets",
        path: "ingressos/listar",
        component: OrganizerListTickets,
        children: [
          {
            name: "OrganizerTicketReprints",
            path: ":number(\\d+)/reimpressoes",
            components: {
              content: OrganizerTicketReprints
            },
            meta: {
              showModal: true
            }
          }
        ]
      },
      {
        name: "OrganizerApp",
        path: "aplicativo",
        component: OrganizerApp
      },
      {
        name: "OrganizerAppPrint",
        path: "aplicativo-ativar-impressao",
        component: OrganizerAppPrint
      },
      {
        name: "OrganizerAppValidate",
        path: "aplicativo-ativar-validacao",
        component: OrganizerAppValidate
      },
      {
        name: "OrganizerPrintReport",
        path: "relatorio/impressao",
        component: OrganizerPrintReport
      },
      {
        name: "OrganizerTimeReport",
        path: "relatorio/entrada",
        component: OrganizerTimeReport
      },
      {
        name: "OrganizerTicketTransfer",
        path: "relatorio/alteracao-titularidade",
        component: OrganizerTicketTransfer
      },
      {
        name: "OrganizerCreateStore",
        path: "loja/criar",
        component: OrganizerCreateStore
      },
      {
        name: "OrganizerOrdersList",
        path: "pedidos/listar",
        component: OrganizerOrdersList
      },
      {
        name: "Coupons",
        path: "cupons",
        component: Coupons
      },
      {
        name: "OrganizerCategories",
        path: "categorias",
        component: OrganizerCategories
      },
      {
        name: "OrganizerOverview",
        path: "",
        component: OrganizerOverview
      }
    ]
  },
  {
    name: "OrganizerRenderTickets",
    path:
      "/organizador/:organizer/revendedor/:dealer/lote/:batch/quantidade/:quantity/imprimir",
    component: OrganizerRenderTickets
  },
  {
    name: "OrganizerReRenderTickets",
    path: "/organizador/:organizer/reimprimir/:numbers",
    component: OrganizerRenderTickets
  },
  {
    path: "/revendedor/:dealer",
    component: DealerDashboard,
    children: [
      {
        name: "DealerOverview",
        path: "",
        component: DealerOverview
      },
      {
        name: "DealerCreateTickets",
        path: "ingressos/imprimir",
        component: DealerCreateTickets
      },
      {
        name: "DealerListTickets",
        path: "ingressos/listar",
        component: DealerListTickets
      }
    ]
  },
  {
    name: "DealerRenderTickets",
    path: "/revendedor/:dealer/lote/:batch/quantidade/:quantity/imprimir",
    component: DealerRenderTickets
  },
  {
    name: "DealerReRenderTickets",
    path: "/revendedor/:dealer/reimprimir/:numbers",
    component: DealerRenderTickets
  },
  {
    path: "*",
    component: PageNotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
